import useGroups from 'hooks/useGroups'
import NotFound from 'pages/NotFound'
import GroupMetricForm from 'pages/shared/GroupMetricForm'
import React from 'react'
import { useParams } from 'react-router-dom'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'
import _ from 'underscore'

const EditGroupMetric = () => {
  const { groups, areGroupsLoaded } = useGroups()
  const { id } = useParams()

  if (!areGroupsLoaded) {
    return <LoadingSinglePanePage />
  }

  const groupMetric = _.find(groups, (group) => group.groupId.toString() === id)

  return (
    <SinglePanePage>
      {
        groupMetric ? (
          <GroupMetricForm
          title="Edit Group Metric"
          saveMethod="update"
          groupMetric={groupMetric}
          />
        ) : <NotFound />
      }
    </SinglePanePage>
  )
}

export default EditGroupMetric
